import { useLocation } from "react-router";

export const useSearchQuery = () => new URLSearchParams(useLocation().search);
